// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lq-0";